import * as React from 'react';
import { usePerformAction } from 'react-remote-data-hooks';
import api from '../../../../api';
import { AiApiSettings } from '../../../../core';
import UpdateForm from './UpdateForm';

interface IAiApiSettingsProps {
  data?: AiApiSettings;
  reload?: () => void;
}

const AiApiSettingsTab: React.FunctionComponent<IAiApiSettingsProps> = (
  props
) => {
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: AiApiSettings) =>
      api.settings.updateAiApiSettings({
        ...data,
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">
              Ai Engine Api Settings
            </h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Value
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Api Url</td>
                <td>{props.data?.apiUrl}</td>
              </tr>
              <tr>
                <td>Username</td>
                <td>{props.data?.username}</td>
              </tr>
              <tr>
                <td>Password</td>
                <td>{props.data?.password && '*******'}</td>
              </tr>
              <tr>
                <td>Brand Name</td>
                <td>{props.data?.brandName}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default AiApiSettingsTab;
